export default "__VITE_ASSET__e4a86f6b__"